import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=20a45506&scoped=true&"
import script from "./MyProfile.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MyProfile.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MyProfile.vue?vue&type=style&index=0&id=20a45506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a45506",
  null
  
)

export default component.exports